import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type BulkDeleteResult = {
  deletedIds: string[];
  skippedIds: string[];
};

export const useBulkDeleteCompanyDocuments = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<
    { data: BulkDeleteResult },
    Error,
    string[]
  >({
    mutationFn: documentIds =>
      api.post<BulkDeleteResult>('company-documents/bulk-delete', { documentIds }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-documents'] });
    },
  });

  const bulkDeleteCompanyDocuments = async (documentIds: string[]) => {
    const response = await mutateAsync(documentIds);
    return response.data;
  };

  return {
    bulkDeleteCompanyDocuments,
    isLoading,
  };
};
